<aumico-users-edit-organization-profile-general-information-component
    [userOrganization]="organizationProfile"
    [countryOptions]="countryOptions"
    (userOrganizationProfileGeneralInformationChange)="modifyUserOrganizationProfileGeneralInformation($event)"
>
</aumico-users-edit-organization-profile-general-information-component>
